import { AfterViewInit, Component, forwardRef, Injector, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { NgSelectComponent } from '@ng-select/ng-select';

import { Period28To28 } from '@common/models/period28to28';
import { DatesService } from '@common/services';

import { ElementBase } from '../../common';

@Component({
    selector: 'aa-period-selector',
    templateUrl: './period-selector.component.html',
    styleUrls: [
        './period-selector.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PeriodSelectorComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PeriodSelectorComponent extends ElementBase<Period28To28> implements OnInit, AfterViewInit
{
    @Input() nbPeriods: number = 3;
    @ViewChild('pselector') pselector: NgSelectComponent;
    public readonly periodField = 'period';
    public periods: Period28To28[];

    constructor (
        private datesService: DatesService,
        injector: Injector
    )
    {
        super(injector);
    }

    ngOnInit ()
    {
        this.periods = this.datesService.calendar28To28(this.nbPeriods);
    }

    ngAfterViewInit ()
    {
        this.pselector.open();
    }

    onChange = ():void =>
    {
        this.pselector.close();
    };

    groupByFn = (item: Period28To28) =>
        item.until.year;
    groupValueFn = (_: string, children: any[]) =>
        ({ name: children[0].name, year: children[0].until.year });
}
